import React from 'react';
import { Link } from 'react-router-dom';

export const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="font-['Bodoni_Moda'] text-4xl font-bold text-[#2A2A2A] mb-8">
          Terms of Service
        </h1>

        <div className="prose prose-lg max-w-none text-[#444]">
          <p className="text-sm text-[#666] mb-8">Last updated: January 2026</p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Agreement to Terms
          </h2>
          <p>
            By accessing or using the Country Bo Foods website, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our site.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Products and Pricing
          </h2>
          <p>
            All product descriptions and prices are subject to change without notice. We reserve the right to discontinue any product at any time. Prices do not include shipping or applicable taxes, which will be calculated at checkout.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Orders and Payment
          </h2>
          <p>
            By placing an order, you represent that you are authorized to use the payment method provided. We reserve the right to refuse or cancel any order for any reason, including suspected fraud or errors in pricing.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Shipping
          </h2>
          <p>
            Shipping times are estimates and not guaranteed. We are not responsible for delays caused by shipping carriers or circumstances beyond our control. Risk of loss passes to you upon delivery to the carrier.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Intellectual Property
          </h2>
          <p>
            All content on this website, including text, images, logos, and product designs, is the property of Country Bo Foods and is protected by copyright and trademark laws. You may not use our content without written permission.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Limitation of Liability
          </h2>
          <p>
            Country Bo Foods shall not be liable for any indirect, incidental, or consequential damages arising from your use of our products or website. Our liability is limited to the amount you paid for the product in question.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Contact
          </h2>
          <p>
            Questions about these Terms? Please{' '}
            <Link to="/contact" className="text-[#D4540A] hover:underline">
              contact us
            </Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
